import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { WdxButtonModule } from '@wdx/shared/components/wdx-button';

import {
    CustomOutputHandler,
    CustomInputHandler,
    WdxJsonViewerComponent,
} from '@wdx/shared/components/wdx-json-editor';

import { IWrappedFormComponent } from '@wdx/shared/infrastructure/form-framework';
import {
    TranslateTokenisedStringPipe,
    WorkflowConfiguration,
} from '@wdx/shared/utils';
import { Observable } from 'rxjs';
import { WorkflowDesignerComponent } from '../workflow-designer/workflow-designer.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkflowDesignerModule } from '../../workflow-designer.module';
import { IWrappedWorkflowFormComponentProvider } from '../../interfaces';
import { WorkflowDesignerConfig } from '../../models/workflow-designer-config';

@Component({
    selector: 'clmi-workflow-designer-json-editor',
    templateUrl: './workflow-designer-json-editor.component.html',
    styleUrl: './workflow-designer-json-editor.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        WdxJsonViewerComponent,
        WdxButtonModule,
        TranslateTokenisedStringPipe,
        WorkflowDesignerModule,
    ],
})
export class WorkflowDesignerJsonEditorComponent
    implements IWrappedFormComponent
{
    private modalService = inject(NgbModal);

    [key: string]: any;
    blurred?: Observable<void>;
    validationErrorMessage?: string;

    @Input() formControl?: any;
    @Input() formData?: any;
    @Input() entityId?: string;
    @Input() customInputHandler?: CustomInputHandler;
    @Input() customOutputHandler?: CustomOutputHandler;
    @Input() componentProvider?: IWrappedWorkflowFormComponentProvider;

    public DESIGNER_LABEL = 'WORKFLOW_DESIGNER_JSON_LABEL';

    public get targetEntityType() {
        return this.formData?.targetEntityType;
    }

    openDesigner(): void {
        const modalRef = this.modalService.open(WorkflowDesignerComponent, {
            windowClass: 'modal-window--ngb modal-fullscreen',
            animation: true,
            fullscreen: true,
            beforeDismiss: () => {
                const instance =
                    modalRef.componentInstance as WorkflowDesignerComponent;
                return instance?.onBeforeDismiss?.() ?? true;
            },
            modalDialogClass: 'clmi-workflow-designer',
        });

        const instance =
            modalRef.componentInstance as WorkflowDesignerComponent;

        instance.config = {
            entityId: this.entityId,
            code: this.formData.code,
            name: this.formData.name,
            configuration: this.parseWorkflowConfig(),
            targetEntityType: this.targetEntityType,
            type: this.formData.type,
        } as WorkflowDesignerConfig;
        instance.workflowOutput.subscribe((output) => {
            this.formControl.setValue(JSON.stringify(output));
        });
        instance.componentProvider = this.componentProvider;
    }

    writeValue(obj: any): void {
        return;
    }
    registerOnChange(fn: any): void {
        return;
    }
    registerOnTouched(fn: any): void {
        return;
    }
    setDisabledState?(isDisabled: boolean): void {
        return;
    }

    private parseWorkflowConfig(): WorkflowConfiguration {
        let parsedConfig: WorkflowConfiguration = { logicSteps: [] };
        try {
            parsedConfig = this.formData.configuration
                ? JSON.parse(this.formData.configuration)
                : {};
        } catch (e) {
            // do nothing
        }

        if (!parsedConfig.logicSteps) {
            parsedConfig.logicSteps = [];
        }
        return parsedConfig;
    }
}
